module.exports = __webpack_public_path__ + "static/media/location.82f8b12f.svg";